import React from 'react'
import './ProductsItem.scss'
import { Link } from 'react-router-dom'

import Wirerod from '../../../assets/Pictures/Products/wirerod.jpg'
import Steelrebar from '../../../assets/Pictures/Products/steelrebar.jpg'
import StandardsGalvanizedWire from '../../../assets/Pictures/Products/Alambre-Galvanizado.jpg'
import Steelignot from '../../../assets/Pictures/Products/Steelignot.jpg'
import EPIndustrialCooler from '../../../assets/Pictures/Products/EP-Industrial-cooler.jpg'

export default function ProductsItem() {
  return (
    <div className='productsItemAr'>
      <div className='container'>
        <div className='row'>
          <div className='product'>
            <Link to='/ar/wirerod' className="item">
              <img src={Wirerod} alt="Wirerod" />
              <div className="text">
                منتجاتنا
              </div>
            </Link>
            <Link to='/ar/steelrebar' className="item">
              <img src={Steelrebar} alt="Wirerod" />
              <div className="text">
                حديد التسليح
              </div>
            </Link>
            <Link to='/ar/standardgalvanizedwire' className="item">
              <img src={StandardsGalvanizedWire} alt="Wirerod" />
              <div className="text">
                الأسلاك المجلفنة القياسية 
              </div>
            </Link>
            <Link to='/ar/steelingot' className="item">
              <img src={Steelignot} alt="Wirerod" />
              <div className="text">
                سبيكة الصلب (البليت)
              </div>
            </Link>
          </div>
          <div className='product' style={{ justifyContent: 'right', marginTop: '1em' }}>
            <Link to='/ar/EPIndustrialCooler' className="item">
              <img src={EPIndustrialCooler} alt="Wirerod" />
              <div className="text">
                EP Industrial cooler
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
